$(document).ready(function() {
    $('.collapse-order').on('hide.bs.collapse', function () {
        // do something…
        $(this).parent().removeClass('collapse--active')
    })
    $('.collapse-order').on('show.bs.collapse', function () {
        // do something…
        $(this).parent().addClass('collapse--active')
    })
});